import axios, { AxiosRequestConfig } from "axios";
import store from '@/store';

export default ({ requiresAuth = true } = {}) => {
  const options: AxiosRequestConfig = {};
  const link = process.env.VUE_APP_API_URL;
  options.baseURL = link;
  const token = store.state.Authenticate?.user?.token;
  options.headers = {
    "Content-type": "application/json",
    Access: "application/json"
  };
  if (requiresAuth) {
    options.headers.Authorization = "Bearer " + token;
  }
  const instance = axios.create(options);
  instance.interceptors.response.use(
    res => res,
    async err => {
      if (err.response.status === 401) {
        await store.dispatch("Authenticate/logout");
      }
      return Promise.reject(err);
    }
  );
  return instance;
};